<script setup lang="ts">
import logo from '~/assets/img/auth_logo.svg';
import authBannerBg from '~/assets/img/auth_banner_bg.svg';

const { src = authBannerBg, rounded = '40px' } = defineProps<{
  src?: string;
  rounded?: string | number;
}>();
</script>

<template>
  <div class="app-banner-background">
    <v-img :src="src" cover class="banner-image" :style="{ borderRadius: rounded }">
      <div class="banner-overlay">
        <div class="banner-logo">
          <img :src="logo" :alt="useRuntimeConfig().public.appName" class="logo-icon" />
        </div>
        <div class="banner-tagline">
          <h1 class="font-title-1">Post a Listing.<br />Get It Done.</h1>
        </div>
        <slot />
      </div>
    </v-img>
  </div>
</template>

<style lang="scss" scoped>
@use '#core/assets/scss/partials/fonts' as *;

.app-banner-background {
  width: 100%;
  height: 100%;
  min-height: 600px;
}

.banner-image {
  width: 100%;
  height: 100%;
  min-height: 600px;
}

.banner-overlay {
  width: 100%;
  height: 100%;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 80px 48px;
  gap: 32px;
}

.banner-logo {
  display: flex;
  align-items: center;
  gap: 8px;

  .logo-icon-wrapper {
    width: 24px;
    height: 24px;
    background-color: #FFC107;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;

    .logo-icon {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .logo-text {
    font-family: $font-family-primary;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #ffffff;
  }
}

.banner-tagline {
  h1 {
    color: #ffffff;
    margin: 0;
  }
}
</style>
